import { useMemo } from "react";
import { useRootCfgObject, } from "@plansoft-configuration-renderer/framework";
import { useLayoutId, useLayoutSuspenseRecord, } from "@plansoft-configuration-renderer/layout";
import { composeAttributePath } from "./composeAttributePath";
import { findConfigurationItemParentsFromConfigurationObject } from "./findConfigurationItemParentsFromConfigurationObject";
import { findConfigurationItemParentsFromLayout } from "./findConfigurationItemParentsFromLayout";
import { useLoadConfigurationObjectStubsByPath } from "./useLoadConfigurationObjectStubByPath";
/**
 * FIXME return a function to use on demand would be better, but react query does not support it
 *
 * Overview:
 * - fetches configuration object for all required paths
 * - fetches layouts
 * - finds the attribute in the layout
 * @returns
 */
export function useConfigurationAttributeParents(options) {
    const { configurationObjectPath, attributeId, basePath } = options;
    const layoutId = useLayoutId();
    const rootCfgObject = useRootCfgObject();
    const { data: configuration } = useLoadConfigurationObjectStubsByPath({
        path: configurationObjectPath,
    });
    const configurationObjects = useMemo(() => { var _a; return (_a = configuration === null || configuration === void 0 ? void 0 : configuration.objects) !== null && _a !== void 0 ? _a : []; }, [configuration === null || configuration === void 0 ? void 0 : configuration.objects]);
    const cfgObjectIds = useMemo(() => { var _a; return (_a = configurationObjects.map((o) => o.id)) !== null && _a !== void 0 ? _a : []; }, [configurationObjects]);
    const rootCfgObjectId = rootCfgObject.id;
    const { layouts } = useLayoutSuspenseRecord({
        cfgObjectIds,
        rootCfgObjectId,
        layoutId,
        basePath,
    });
    return useMemo(() => configurationObjects.flatMap((configurationObject) => {
        const layout = layouts[configurationObject.id];
        const findOptions = {
            configurationObjectPath,
            attributeId,
            attributePath: composeAttributePath({
                configurationObjectPath,
                attributeId,
            }),
        };
        if (!layout) {
            return findConfigurationItemParentsFromConfigurationObject(configurationObject, findOptions);
        }
        return findConfigurationItemParentsFromLayout(layout, configurationObject, findOptions);
    }), [attributeId, configurationObjectPath, configurationObjects, layouts]);
}
//# sourceMappingURL=useConfigurationAttributeParents.js.map